// Simple print helper that opens a new window with a formatted A4 printout.
const fmt = (n) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(n || 0);

const shell = (title, body) => `<!doctype html><html><head><meta charset="utf-8"/>
<title>${title}</title>
<style>
  @page { size: A4; margin: 18mm 16mm; }
  body { font-family: 'IBM Plex Sans', system-ui, sans-serif; color:#1C1C1C; padding: 8px; }
  h1,h2,h3 { font-family: 'Manrope', sans-serif; letter-spacing:-0.02em; margin: 0 0 4px; }
  .brand { display:flex; align-items:center; gap:12px; border-bottom:1px solid #E5E5E2; padding-bottom:16px; margin-bottom:20px; }
  .brand .name { font-family:'Manrope',sans-serif; font-weight:800; font-size:22px; letter-spacing:-0.02em; }
  .brand .tag { color:#52525B; font-size:11px; letter-spacing:.2em; text-transform:uppercase; }
  .pill { display:inline-block; background:#0F4C3A; color:#fff; border-radius:6px; padding:6px 10px; font-family:'Manrope'; font-weight:700; }
  .grid { display:grid; grid-template-columns: 1fr 1fr; gap:24px; margin-bottom:16px; }
  .label { font-size:10px; text-transform:uppercase; letter-spacing:.12em; color:#52525B; font-weight:600; }
  table { width:100%; border-collapse:collapse; margin-top:12px; font-size:13px; }
  th { text-align:left; color:#52525B; font-size:11px; text-transform:uppercase; letter-spacing:.1em; padding:8px 6px; border-bottom:1px solid #E5E5E2; }
  td { padding:8px 6px; border-bottom:1px solid #F4F4F5; }
  .totals { margin-top:16px; margin-left:auto; width:280px; font-size:13px; }
  .totals .row { display:flex; justify-content:space-between; padding:4px 0; }
  .totals .grand { border-top:1px solid #1C1C1C; margin-top:6px; padding-top:8px; font-weight:800; font-family:'Manrope'; font-size:16px; }
  .footer { margin-top:32px; font-size:10px; color:#A1A1AA; border-top:1px solid #E5E5E2; padding-top:12px; }
  .num { font-family:'IBM Plex Mono', monospace; font-variant-numeric: tabular-nums; }
  .rx-row { padding:10px 6px; border-bottom:1px solid #F4F4F5; }
  .rx-drug { font-weight:700; font-size:15px; }
  .rx-meta { color:#52525B; font-size:12px; margin-top:2px; }
</style>
</head><body>${body}</body></html>`;

const brand = () => `
  <div class="brand">
    <div style="width:36px;height:36px;background:#0F4C3A;border-radius:8px;display:flex;align-items:center;justify-content:center;color:#fff;font-family:Manrope;font-weight:800;">D</div>
    <div><div class="name">DentOS</div><div class="tag">Dental Studio · Baner, Pune</div></div>
  </div>`;

export function printPrescription(rx, patient) {
  const w = window.open("", "_blank"); if (!w) return;
  const body = `
    ${brand()}
    <div class="grid">
      <div><div class="label">Patient</div><div style="font-weight:700;font-size:16px;">${patient.full_name}</div>
      <div style="color:#52525B;font-size:12px;">${patient.mrn} · ${patient.gender || ""} · <span class="num">${patient.phone}</span></div></div>
      <div style="text-align:right;"><div class="label">Date</div><div class="num">${new Date(rx.created_at).toLocaleDateString("en-IN")}</div></div>
    </div>
    <h2>Prescription</h2>
    <div style="margin-top:12px;">${rx.items.map((it) => `
      <div class="rx-row">
        <div class="rx-drug">℞ ${it.drug} <span style="font-weight:400;color:#52525B;">${it.dose}</span></div>
        <div class="rx-meta">${it.frequency || ""}${it.frequency && it.duration ? " · " : ""}${it.duration || ""}${it.instructions ? " · " + it.instructions : ""}</div>
      </div>`).join("")}
    </div>
    ${rx.advice ? `<div style="margin-top:16px;"><div class="label">Advice</div><div style="font-size:13px;">${rx.advice}</div></div>` : ""}
    <div style="margin-top:56px;text-align:right;">
      <div style="border-top:1px solid #1C1C1C;display:inline-block;padding-top:6px;min-width:200px;font-size:12px;color:#52525B;">Signature · Registered Dentist</div>
    </div>
    <div class="footer">Generated by DentOS · Not valid without prescriber signature.</div>`;
  w.document.write(shell(`Rx ${patient.mrn}`, body));
  w.document.close(); w.focus();
  setTimeout(() => w.print(), 300);
}

export function printInvoice(inv, patient) {
  const w = window.open("", "_blank"); if (!w) return;
  const rows = inv.items.map((it) => {
    const line = it.qty * it.unit_price;
    const gst = line * (it.gst_rate / 100);
    return `<tr>
      <td>${it.description}</td>
      <td class="num" style="text-align:right;">${it.qty}</td>
      <td class="num" style="text-align:right;">${fmt(it.unit_price)}</td>
      <td class="num" style="text-align:right;">${it.gst_rate}%</td>
      <td class="num" style="text-align:right;">${fmt(line + gst)}</td>
    </tr>`;
  }).join("");
  const body = `
    ${brand()}
    <div class="grid">
      <div><div class="label">Billed to</div>
        <div style="font-weight:700;font-size:16px;">${patient.full_name}</div>
        <div style="color:#52525B;font-size:12px;">${patient.mrn}${patient.address ? " · " + patient.address : ""}</div>
      </div>
      <div style="text-align:right;">
        <div class="label">Invoice</div>
        <div class="num" style="font-weight:700;">${inv.invoice_no}</div>
        <div class="num" style="color:#52525B;font-size:12px;">${new Date(inv.created_at).toLocaleDateString("en-IN")}</div>
        <div class="pill" style="margin-top:6px;text-transform:uppercase;font-size:11px;letter-spacing:.1em;">${inv.status}</div>
      </div>
    </div>
    <table>
      <thead><tr><th>Description</th><th style="text-align:right;">Qty</th><th style="text-align:right;">Unit</th><th style="text-align:right;">GST</th><th style="text-align:right;">Amount</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>
    <div class="totals">
      <div class="row"><span>Subtotal</span><span class="num">${fmt(inv.subtotal)}</span></div>
      <div class="row"><span>GST</span><span class="num">${fmt(inv.gst_total)}</span></div>
      ${inv.discount ? `<div class="row"><span>Discount</span><span class="num">-${fmt(inv.discount)}</span></div>` : ""}
      <div class="row grand"><span>Total</span><span class="num">${fmt(inv.total)}</span></div>
      <div class="row"><span>Paid (${(inv.payment_mode || "pending").toUpperCase()})</span><span class="num">${fmt(inv.amount_paid)}</span></div>
      <div class="row" style="color:${inv.balance > 0 ? "#991B1B" : "#166534"};font-weight:700;"><span>Balance</span><span class="num">${fmt(inv.balance)}</span></div>
    </div>
    <div class="footer">Thank you. This is a computer-generated invoice · GST-compliant.</div>`;
  w.document.write(shell(`Invoice ${inv.invoice_no}`, body));
  w.document.close(); w.focus();
  setTimeout(() => w.print(), 300);
}
